// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SingleSelectSearchDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   showSelectAll,
//   disabled,
//   singleSelect = false, // defaults to false
//   onSearchInputChange, // Parent function to trigger API call
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [searchKey, setSearchKey] = useState(""); // Search input state
//   const [filteredOptions, setFilteredOptions] = useState(options); // Filtered options
//   const dropdownRef = useRef(null);

//   // Update filtered options whenever options change
//   useEffect(() => {
//     setFilteredOptions(options);
//   }, [options]);

//   // Close dropdown on clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Update filtered options based on searchKey
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(options);
//     } else {
//       setFilteredOptions(
//         options.filter((option) =>
//           option.label.toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//   }, [searchKey, options]);

//   // When auto-selection changes, clear searchKey so displayValue comes from selected options
//   useEffect(() => {
//     if (selected && selected.length > 0) {
//       setSearchKey("");
//     }
//   }, [selected]);

//   const handleSelect = (option) => {
//     if (singleSelect) {
//       setSelected(option.id);
//       setSearchKey("");
//       setIsActive(false);
//     } else {
//       const isSelected = selected.includes(option.id);
//       if (isSelected) {
//         setSelected(selected.filter((id) => id !== option.id));
//       } else {
//         setSelected([...selected, option.id]);
//       }
//     }
//   };

//   const handleSelectAll = () => {
//     if (singleSelect) return;
//     if (selected.length === options.length) {
//       setSelected([]);
//     } else {
//       setSelected(options.map((option) => option.id));
//     }
//   };

//   // Clear current selection and searchKey
//   const clearValue = () => {
//     if (singleSelect) {
//       setSelected("");
//     } else {
//       setSelected([]);
//     }
//     setSearchKey("");
//   };

//   // Compute display value: when there is a selection, show the joined labels; otherwise show searchKey.
//   const displayValue = singleSelect
//     ? options.find((opt) => opt.id === selected)?.label || searchKey
//     : selected.length > 0
//     ? options
//         .filter((opt) => selected.includes(opt.id))
//         .map((opt) => opt.label)
//         .join(", ")
//     : searchKey;

//   const handleChange = (e) => {
//     const newKey = e.target.value;
//     setSearchKey(newKey);
//     if (onSearchInputChange) {
//       onSearchInputChange(newKey);
//     }
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{
//         width,
//         marginLeft,
//         marginTop,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//       }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>

//       <div className="dropdown-btn" onClick={() => setIsActive(true)}>
//         <input
//           type="text"
//           className="dropdown-input"
//           style={{ color: "#6A6A6A" }}
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleChange}
//           onFocus={() => setIsActive(true)}
//         />
//         {displayValue && (
//           <span
//             style={{
//               cursor: "pointer",
//               color: "#aaa",
//               marginRight: "30px",
//               fontSize: "16px",
//               userSelect: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               clearValue();
//             }}
//           >
//             ×
//           </span>
//         )}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>

//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: "200px",
//             overflowY: "scroll",
//           }}
//         >
//           {showSelectAll && !singleSelect && options.length > 0 && (
//             <div
//               className="dropdown-item"
//               style={{ display: "flex", alignItems: "center", gap: "10px" }}
//             >
//               <input
//                 type="checkbox"
//                 className="delete-question-checkbox-dqc"
//                 checked={
//                   selected.length > 0 && selected.length === options.length
//                 }
//                 onChange={handleSelectAll}
//               />
//               <label onClick={handleSelectAll}>Select All</label>
//             </div>
//           )}

//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 style={{ display: "flex", alignItems: "center", gap: "10px" }}
//               >
//                 {/* <input
//                   type="checkbox"
//                   className="delete-question-checkbox-dqc"
//                   checked={
//                     singleSelect
//                       ? selected === option.id
//                       : selected.includes(option.id)
//                   }
//                   onChange={() => handleSelect(option)}
//                 /> */}
//                 <label onClick={() => handleSelect(option)}>
//                   {option.label}
//                 </label>
//               </div>
//             ))
//           ) : (
//             <div className="dropdown-no-results">No results found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }





























// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SingleSelectSearchDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   showSelectAll,
//   disabled,
//   singleSelect = false, // defaults to false
//   onSearchInputChange, // Parent function to trigger API call
//   selectedOptionProp = null, // New: preselected option object
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [searchKey, setSearchKey] = useState(""); // Search input state
//   const [filteredOptions, setFilteredOptions] = useState(options); // Filtered options
//   const [selectedOptionObj, setSelectedOptionObj] = useState(selectedOptionProp); // Preselected object
//   const dropdownRef = useRef(null);

//   // Update filtered options whenever options change
//   useEffect(() => {
//     setFilteredOptions(options);
//   }, [options]);

//   // Initialize preselected value
//   useEffect(() => {
//     setSelectedOptionObj(selectedOptionProp);
//     if (selectedOptionProp) {
//       setSelected(singleSelect ? selectedOptionProp.id : [selectedOptionProp.id]);
//     }
//   }, [selectedOptionProp]);

//   // Close dropdown on clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Update filtered options based on searchKey
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(options);
//     } else {
//       setFilteredOptions(
//         options.filter((option) =>
//           option.label.toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//   }, [searchKey, options]);

//   // Clear searchKey when selected changes
//   useEffect(() => {
//     if (selected && ((Array.isArray(selected) && selected.length > 0) || selected)) {
//       setSearchKey("");
//     }
//   }, [selected]);

//   const handleSelect = (option) => {
//     if (singleSelect) {
//       setSelected(option.id);
//       setSelectedOptionObj(option); // Keep full object for display
//       setSearchKey("");
//       setIsActive(false);
//     } else {
//       const isSelected = selected.includes(option.id);
//       if (isSelected) {
//         setSelected(selected.filter((id) => id !== option.id));
//       } else {
//         setSelected([...selected, option.id]);
//       }
//     }
//   };

//   const handleSelectAll = () => {
//     if (singleSelect) return;
//     if (selected.length === options.length) {
//       setSelected([]);
//     } else {
//       setSelected(options.map((option) => option.id));
//     }
//   };

//   const clearValue = () => {
//     if (singleSelect) {
//       setSelected("");
//       setSelectedOptionObj(null);
//     } else {
//       setSelected([]);
//     }
//     setSearchKey("");
//   };

//   const displayValue = singleSelect
//     ? selectedOptionObj?.label || searchKey
//     : selected.length > 0
//     ? options
//         .filter((opt) => selected.includes(opt.id))
//         .map((opt) => opt.label)
//         .join(", ")
//     : searchKey;

//   const handleChange = (e) => {
//     const newKey = e.target.value;
//     setSearchKey(newKey);
//     if (onSearchInputChange) onSearchInputChange(newKey);
//     setIsActive(true);
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{
//         width,
//         marginLeft,
//         marginTop,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//       }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>

//       <div className="dropdown-btn" onClick={() => setIsActive(true)}>
//         <input
//           type="text"
//           className="dropdown-input"
//           style={{ color: "#6A6A6A" }}
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleChange}
//           onFocus={() => setIsActive(true)}
//           readOnly={disabled}
//         />
//         {displayValue && (
//           <span
//             style={{
//               cursor: "pointer",
//               color: "#aaa",
//               marginRight: "30px",
//               fontSize: "16px",
//               userSelect: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               clearValue();
//             }}
//           >
//             ×
//           </span>
//         )}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>

//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: "200px",
//             overflowY: "scroll",
//           }}
//         >
//           {showSelectAll && !singleSelect && options.length > 0 && (
//             <div
//               className="dropdown-item"
//               style={{ display: "flex", alignItems: "center", gap: "10px" }}
//             >
//               <input
//                 type="checkbox"
//                 className="delete-question-checkbox-dqc"
//                 checked={selected.length > 0 && selected.length === options.length}
//                 onChange={handleSelectAll}
//               />
//               <label onClick={handleSelectAll}>Select All</label>
//             </div>
//           )}

//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 style={{ display: "flex", alignItems: "center", gap: "10px" }}
//               >
//                 <label onClick={() => handleSelect(option)}>{option.label}</label>
//               </div>
//             ))
//           ) : (
//             <div className="dropdown-no-results">No results found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
























// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SingleSelectSearchDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   showSelectAll,
//   disabled,
//   singleSelect = false, // defaults to false
//   onSearchInputChange, // Parent function to trigger API call
//   selectedOptionProp = null, // optional: preselected option object
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [searchKey, setSearchKey] = useState(""); // Search input state
//   const [filteredOptions, setFilteredOptions] = useState(options); // Filtered options
//   const [selectedOptionObj, setSelectedOptionObj] = useState(
//     selectedOptionProp || null
//   ); // Preselected object
//   const dropdownRef = useRef(null);

//   // Update filtered options whenever options change
//   useEffect(() => {
//     setFilteredOptions(options);
//   }, [options]);

//   // If parent provides selectedOptionProp explicitly prefer that
//   useEffect(() => {
//     if (selectedOptionProp) {
//       setSelectedOptionObj(selectedOptionProp);
//       if (singleSelect) {
//         setSelected(selectedOptionProp.id);
//       } else {
//         // not used for multi-select here, but keep parity
//         setSelected([selectedOptionProp.id]);
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedOptionProp]);

//   // Ensure selectedOptionObj is synced with `selected` and `options`
//   // This is the important fix: when parent passes selected id and options contains that id
//   // we pick the object so the input shows a label.
//   useEffect(() => {
//     if (selectedOptionProp) return; // prop has priority
//     if (!singleSelect) return;

//     if (selected === null || selected === undefined || selected === "") {
//       setSelectedOptionObj(null);
//       return;
//     }

//     const found = options.find((o) => String(o.id) === String(selected));
//     if (found) {
//       setSelectedOptionObj(found);
//     } else {
//       setSelectedOptionObj(null);
//     }
//   }, [selected, options, selectedOptionProp, singleSelect]);

//   // Close dropdown on clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Update filtered options based on searchKey
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(options);
//     } else {
//       setFilteredOptions(
//         options.filter((option) =>
//           (option.label || "")
//             .toString()
//             .toLowerCase()
//             .includes(searchKey.toLowerCase())
//         )
//       );
//     }
//   }, [searchKey, options]);

//   // Clear searchKey when selected changes
//   useEffect(() => {
//     if (
//       selected &&
//       ((Array.isArray(selected) && selected.length > 0) || selected)
//     ) {
//       setSearchKey("");
//     }
//   }, [selected]);

//   const handleSelect = (option) => {
//     if (singleSelect) {
//       setSelected(option.id);
//       setSelectedOptionObj(option); // Keep full object for display
//       setSearchKey("");
//       setIsActive(false);
//     } else {
//       const isSelected = Array.isArray(selected) && selected.includes(option.id);
//       if (isSelected) {
//         setSelected(selected.filter((id) => id !== option.id));
//       } else {
//         setSelected([...(selected || []), option.id]);
//       }
//     }
//   };

//   const handleSelectAll = () => {
//     if (singleSelect) return;
//     if (selected.length === options.length) {
//       setSelected([]);
//     } else {
//       setSelected(options.map((option) => option.id));
//     }
//   };

//   const clearValue = () => {
//     if (singleSelect) {
//       setSelected("");
//       setSelectedOptionObj(null);
//     } else {
//       setSelected([]);
//     }
//     setSearchKey("");
//   };

//   // Display value: prefer the selectedOptionObj label, fallback to looking it up in options (in case the object wasn't set),
//   // otherwise show searchKey (so typing works)
//   const lookupLabelFromOptions = () => {
//     if (!singleSelect) return "";
//     const found = options.find((o) => String(o.id) === String(selected));
//     return found ? found.label : "";
//   };

//   const displayValue = singleSelect
//     ? selectedOptionObj?.label || lookupLabelFromOptions() || searchKey || ""
//     : selected && selected.length > 0
//     ? options
//         .filter((opt) => selected.includes(opt.id))
//         .map((opt) => opt.label)
//         .join(", ")
//     : searchKey;

//   const handleChange = (e) => {
//     const newKey = e.target.value;
//     setSearchKey(newKey);
//     if (onSearchInputChange) onSearchInputChange(newKey);
//     setIsActive(true);
//     // When user types, clear selectedOptionObj (they are searching for something new)
//     if (singleSelect) setSelectedOptionObj(null);
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{
//         width,
//         marginLeft,
//         marginTop,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//       }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>

//       <div
//         className="dropdown-btn"
//         onClick={() => {
//           if (!disabled) setIsActive(true);
//         }}
//       >
//         <input
//           type="text"
//           className="dropdown-input"
//           style={{ color: "#6A6A6A" }}
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleChange}
//           onFocus={() => setIsActive(true)}
//           readOnly={disabled ? true : false}
//         />
//         {displayValue && (
//           <span
//             style={{
//               cursor: "pointer",
//               color: "#aaa",
//               marginRight: "30px",
//               fontSize: "16px",
//               userSelect: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               clearValue();
//             }}
//           >
//             ×
//           </span>
//         )}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>

//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: "200px",
//             overflowY: "scroll",
//           }}
//         >
//           {showSelectAll && !singleSelect && options.length > 0 && (
//             <div
//               className="dropdown-item"
//               style={{ display: "flex", alignItems: "center", gap: "10px" }}
//             >
//               <input
//                 type="checkbox"
//                 className="delete-question-checkbox-dqc"
//                 checked={
//                   Array.isArray(selected) &&
//                   selected.length > 0 &&
//                   selected.length === options.length
//                 }
//                 onChange={handleSelectAll}
//               />
//               <label onClick={handleSelectAll}>Select All</label>
//             </div>
//           )}

//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 style={{ display: "flex", alignItems: "center", gap: "10px" }}
//               >
//                 <label
//                   onClick={() => handleSelect(option)}
//                   style={{ cursor: "pointer" }}
//                 >
//                   {option.label}
//                 </label>
//               </div>
//             ))
//           ) : (
//             <div className="dropdown-no-results">No results found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }










import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function SingleSelectSearchDropdown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  placeholder = "",
  marginLeft,
  marginTop,
  showSelectAll,
  disabled,
  singleSelect = false,
  onSearchInputChange,
  selectedOptionProp = null,
}) {
  const [isActive, setIsActive] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedOptionObj, setSelectedOptionObj] = useState(
    selectedOptionProp || null
  );
  const dropdownRef = useRef(null);

  // Update filtered options whenever options change
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  // If parent provides selectedOptionProp explicitly prefer that
  useEffect(() => {
    if (selectedOptionProp) {
      setSelectedOptionObj(selectedOptionProp);
      if (singleSelect) {
        setSelected(selectedOptionProp.id);
      } else {
        setSelected([selectedOptionProp.id]);
      }
    }
  }, [selectedOptionProp]);

  // Sync selectedOptionObj with selected and options
  useEffect(() => {
    if (selectedOptionProp) return;
    if (!singleSelect) return;

    if (selected === null || selected === undefined || selected === "") {
      setSelectedOptionObj(null);
      return;
    }

    const found = options.find((o) => String(o.id) === String(selected));
    if (found) {
      setSelectedOptionObj(found);
    } else {
      setSelectedOptionObj(null);
    }
  }, [selected, options, selectedOptionProp, singleSelect]);

  // Close dropdown on clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update filtered options based on searchKey
  useEffect(() => {
    if (searchKey === "") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) =>
          (option.label || "")
            .toString()
            .toLowerCase()
            .includes(searchKey.toLowerCase())
        )
      );
    }
  }, [searchKey, options]);

  // Clear searchKey when selected changes (but only if we have a valid selection)
  useEffect(() => {
    if (
      selected &&
      ((Array.isArray(selected) && selected.length > 0) || selected)
    ) {
      setSearchKey("");
    }
  }, [selected]);

  const handleSelect = (option) => {
    if (singleSelect) {
      setSelected(option.id);
      setSelectedOptionObj(option);
      setSearchKey("");
      setIsActive(false);
    } else {
      const isSelected = Array.isArray(selected) && selected.includes(option.id);
      if (isSelected) {
        setSelected(selected.filter((id) => id !== option.id));
      } else {
        setSelected([...(selected || []), option.id]);
      }
    }
  };

  const handleSelectAll = () => {
    if (singleSelect) return;
    if (selected.length === options.length) {
      setSelected([]);
    } else {
      setSelected(options.map((option) => option.id));
    }
  };

  const clearValue = () => {
    if (singleSelect) {
      setSelected(null);
      setSelectedOptionObj(null);
    } else {
      setSelected([]);
    }
    setSearchKey("");
  };

  // Calculate display value
  const getDisplayValue = () => {
    if (singleSelect) {
      // If we have a selected option object, show its label
      if (selectedOptionObj?.label) {
        return selectedOptionObj.label;
      }
      // If we have a selected ID but no object, look it up
      if (selected) {
        const found = options.find((o) => String(o.id) === String(selected));
        if (found) return found.label;
      }
      // Otherwise show the search key (for typing)
      return searchKey;
    } else {
      // Multi-select logic
      if (selected && selected.length > 0) {
        return options
          .filter((opt) => selected.includes(opt.id))
          .map((opt) => opt.label)
          .join(", ");
      }
      return searchKey;
    }
  };

  const displayValue = getDisplayValue();

  const handleChange = (e) => {
    const newKey = e.target.value;
    setSearchKey(newKey);
    
    // When user starts typing/editing, clear the selection so they can search again
    if (singleSelect && selectedOptionObj) {
      setSelected(null);
      setSelectedOptionObj(null);
    }
    
    if (onSearchInputChange) onSearchInputChange(newKey);
    setIsActive(true);
  };

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>

      <div
        className="dropdown-btn"
        onClick={() => {
          if (!disabled) setIsActive(true);
        }}
      >
        <input
          type="text"
          className="dropdown-input"
          style={{ color: "#6A6A6A" }}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsActive(true)}
          readOnly={disabled ? true : false}
        />
        {displayValue && (
          <span
            style={{
              cursor: "pointer",
              color: "#aaa",
              marginRight: "30px",
              fontSize: "16px",
              userSelect: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              clearValue();
            }}
          >
            ×
          </span>
        )}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>

      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: "200px",
            overflowY: "scroll",
          }}
        >
          {showSelectAll && !singleSelect && options.length > 0 && (
            <div
              className="dropdown-item"
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <input
                type="checkbox"
                className="delete-question-checkbox-dqc"
                checked={
                  Array.isArray(selected) &&
                  selected.length > 0 &&
                  selected.length === options.length
                }
                onChange={handleSelectAll}
              />
              <label onClick={handleSelectAll}>Select All</label>
            </div>
          )}

          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <label
                  onClick={() => handleSelect(option)}
                  style={{ cursor: "pointer" }}
                >
                  {option.label}
                </label>
              </div>
            ))
          ) : (
            <div className="dropdown-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
}